import { IconActionList16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { trackSendMoreClick } from './tracking';
import { ChatbotButton } from '../../components/ChatbotButton';
import { updateRecommendations } from '../../thunks/chatbot';
import { TThunkDispatch } from '../../types/redux/thunk';

export const SendMoreButtonContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();

  const onClick = React.useCallback(() => {
    trackSendMoreClick();
    dispatch(updateRecommendations()).finally();
  }, [dispatch]);

  return (
    <ChatbotButton
      theme="fill_white_primary"
      beforeIcon={<IconActionList16 color="icon-main-default" />}
      onClick={onClick}
    >
      Пришли ещё
    </ChatbotButton>
  );
};
